export default __webpack_public_path__ + "53dcd6e71e422b0ccb9dd667e48721c7.png";